import {Pipe, PipeTransform} from '@angular/core';
import {ILocation} from '../models/ILocation';
import {find} from 'lodash';
import moment from 'moment';
import {TranslationService} from '../translation';

@Pipe({
  standalone: false,
  name: 'fieldFormat'
})
export class FieldFormatPipe implements PipeTransform {
  constructor(
    private ts: TranslationService
  ) {
  }

  transform(value: string, field: string, location: ILocation): string {
    const locationField = find(location.fields, {name: field});
    if (!locationField) {
      return this.formatFallback(value, field);
    }

    switch (locationField.type) {
      case 'date':
        return this.formatDate(value, 'L');
      case 'time':
        return value;
      case 'datetime':
        return this.formatDate(value, 'LT L');
      case 'bool':
        return value === 'true' ? '✔' : '✕';
      default:
        return value;
    }
  }

  private formatFallback(value: string, field: string): string {
    if (field === 'mobilePhone' && value[0] !== '+') {
      return '+' + value;
    }
    if (field === 'title') {
      return this.ts.instant(value);
    }

    return value;
  }

  private formatDate(value: string, format: string): string {
    if (value && moment.utc(value).isValid()) {
      return moment.utc(value).local().format(format);
    }

    return value;
  }
}
